// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B-0S","colBig":"styles_colBig__1KLv2","colSmall":"styles_colSmall__Daq_h"};